
import { Vue } from "vue-class-component";

export default class PencilEditNoSquare extends Vue {}
